import { SlidersHorizontal } from 'lucide-react'
import * as React from 'react'

import { cn } from '../../utils/cn'
import { Button } from './button'
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from './sheet'

interface ActionsSheetProps {
  /** Button label, and the sheet's heading when no `title` is given. */
  label: string
  title?: string
  children: React.ReactNode
  className?: string
}

/**
 * A detail page's action rail on a phone. The rails run 224–240px of selects and
 * buttons, which leaves nothing for the record itself below `lg` — so under that
 * the rail moves behind a button and the page gets its full width back.
 */
export function ActionsSheet({ label, title, children, className }: ActionsSheetProps) {
  return (
    <Sheet>
      <SheetTrigger asChild>
        <Button variant="outline" size="sm" className={cn('lg:hidden', className)}>
          <SlidersHorizontal className="size-3.5" />
          {label}
        </Button>
      </SheetTrigger>
      <SheetContent side="right" className="w-[88vw] overflow-y-auto sm:max-w-sm">
        <SheetHeader>
          <SheetTitle>{title ?? label}</SheetTitle>
        </SheetHeader>
        <div className="flex flex-col gap-3 px-4 pb-8">{children}</div>
      </SheetContent>
    </Sheet>
  )
}
